/** @module csi/widget/_DropDownMenuMixin */
define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		/**
		 * Add class to style left or right menu
		 * @param {object} args - position of the wrapper node
		 */
		onOpen: function(args){
			this.inherited(arguments);
			
			if(args.aroundCorner == "BR") {
				$(this._popupWrapper).toggleClass("csi-left-menu","csi-right-menu");
			} else {
				$(this._popupWrapper).toggleClass("csi-right-menu","csi-left-menu");
			}
		}
	});
});